export const scrollToMessage = (
  messageId: number | string,
  messageRefs: React.MutableRefObject<{ [key: string | number]: HTMLLIElement | null }>,
  keepHighlight: boolean = false,
) => {
  const messageElement = messageRefs.current[messageId] || messageRefs.current[Number(messageId)] || messageRefs.current[String(messageId)]

  if (!messageElement) {
    console.warn(`Message element with ID ${messageId} not found`)
    return
  }

  // Scroll ONLY the message list, not its ancestors. The chat header is
  // absolutely positioned relative to an outer (non-scrolling) container, so
  // element.scrollIntoView() — which scrolls every scrollable ancestor — would
  // also scroll that outer container and push the header off-screen on mobile.
  const getScrollParent = (node: HTMLElement | null): HTMLElement | null => {
    let parent = node?.parentElement || null
    while (parent && parent !== document.body) {
      const overflowY = getComputedStyle(parent).overflowY
      if ((overflowY === 'auto' || overflowY === 'scroll') && parent.scrollHeight > parent.clientHeight) {
        return parent
      }
      parent = parent.parentElement
    }
    return null
  }

  const container = getScrollParent(messageElement)
  if (container) {
    const containerRect = container.getBoundingClientRect()
    const elementRect = messageElement.getBoundingClientRect()
    const top =
      container.scrollTop + (elementRect.top - containerRect.top) - (container.clientHeight - elementRect.height) / 2
    container.scrollTo({ top, behavior: 'smooth' })
  } else {
    messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  messageElement.classList.add('message-highlighted')

  if (!keepHighlight) {
    setTimeout(() => {
      messageElement.classList.remove('message-highlighted')
    }, 2000)
  }
  return undefined
}
